import toast, { ToastOptions } from "react-hot-toast";

const useSnackbar = () => {
  const showSuccess = (message: string, options?: ToastOptions) => {
    toast.success(message, options);
  };

  const showError = (message: string, options?: ToastOptions) => {
    toast.error(message, options);
  };

  const showWarning = (message: string) => {
    toast(message, {
      icon: "⚠️",
      style: {},
    });
  };

  return { showSuccess, showError, showWarning };
};

export default useSnackbar;
